import React from 'react';
import axios, { baseUrl } from 'helpers/axios';

import {
  Container,
  Title,
  TextInput,
  Button,
  Form,
  Image,
  Label,
  TextLink,
} from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';
import { useToasts, useUser, useLayout } from 'hooks';

export const TFASetup = () => {
  const [token, setToken] = React.useState('');
  const { setLayoutLoading } = useLayout();
  const { errorToast } = useToasts();
  const { challenges, saveChallenges, redirectTo } = useUser();
  const timestamp = React.useRef(new Date().getTime());

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLayoutLoading(true);
      const response = await axios.post('/challenges/otp/verify', { token });
      if (response.status === 200) {
        if (response.data?.success) {
          saveChallenges({ valid: true });
          redirectTo('/2fa/success');
          return;
        } else {
          errorToast('Token code is wrong!');
        }
      }
    } catch (error) {
      errorToast({ error, default: 'Error: 2FA setup.' });
    }
    setLayoutLoading(false);
  };

  return (
    <AuthLayout show={challenges.required} justifyContent="center">
      <Container width="80%" maxWidth="480px" height="auto">
        <Container alignItems="center" mb="xl">
          <Image alt="2FA" src="/assets/img/2FA.png" />
        </Container>
        <Title mb="m">Your security matters</Title>
        <Title type="h3" variant="grey" mb="xs">
          <strong>1.</strong>Dowload and Install a supported TOTP Athenticator App
          <br />
          <strong>2.</strong>Open the app
          <br />
          <strong>3.</strong>Pair your app by scanning the QR Code below
        </Title>
        <Container alignItems="center" mb="xs">
          <Image
            width="152px"
            src={`${baseUrl}/challenges/otp/setup/?$qr=true&$format=otpauth_url&t=${timestamp.current}`}
            alt="QR Code"
            onError={() => redirectTo('/2fa/login')}
          />
        </Container>
        <Title type="h3" variant="grey" mb="m">
          <strong>4.</strong>Verifying the pairing by entering the code below
        </Title>
        <Form onSubmit={handleSubmit}>
          <Container mb="xxs">
            <Label htmlFor="token" mb="xs">
              Your token code
            </Label>
            <TextInput
              id="token"
              name="token"
              type="token"
              length={6}
              placeholder="6-digit code"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required
              autoFocus
            />
          </Container>
          <Button type="submit" my="m">
            NEXT
          </Button>
          <TextLink my="m" to="/2fa/sms">
            No I want to use my phone number
          </TextLink>
        </Form>
      </Container>
    </AuthLayout>
  );
};
